module.exports = __webpack_public_path__ + "static/img/0760.8222471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0760.jpg
// module id = 99
// module chunks = 0